import { ClaimFilterType } from './types';

export const claimFiltersMap = {
  status: 'status',
  benefitType: 'benefitType',
} as const;

export const FILTER_BENEFIT_TYPES = [
  {
    name: 'Meal Allowance',
    value: 'mealAllowance',
  },
  {
    name: 'Travel Allowance',
    value: 'travelAllowance',
  },
  {
    name: 'Attire Allowance',
    value: 'attireAllowance',
  },
  {
    name: 'Fuel Allowance',
    value: 'fuelAllowance',
  },
];

export const claimFilters: {
  key: ClaimFilterType;
  label: string;
  color: 'information' | 'positive' | 'negative' | 'notice' | 'neutral';
}[] = [
  { key: 'all', label: 'All', color: 'information' },
  { key: 'submitted', label: 'Pending', color: 'information' },
  { key: 'rejected', label: 'Rejected', color: 'negative' },
  { key: 'approved', label: 'Approved', color: 'positive' },
];
